var map = {
	"./AdAnalysis/materials.md": 604,
	"./AnalyzingPrimarySources/grade-levels.md": 601,
	"./AnalyzingPrimarySources/materials.md": 602,
	"./AnalyzingPrimarySources/objectives.md": 600,
	"./AnalyzingPrimarySources/overview.md": 599,
	"./AnalyzingPrimarySources/procedures.md": 603,
	"./LordDunmoreProclamation/assessments.md": 588,
	"./LordDunmoreProclamation/background.md": 586,
	"./LordDunmoreProclamation/grade-levels.md": 584,
	"./LordDunmoreProclamation/materials.md": 585,
	"./LordDunmoreProclamation/objectives.md": 582,
	"./LordDunmoreProclamation/overview.md": 581,
	"./LordDunmoreProclamation/procedures.md": 587,
	"./LordDunmoreProclamation/time.md": 583,
	"./RewritingTheNarrative/assessment.md": 580,
	"./RewritingTheNarrative/grade-levels.md": 576,
	"./RewritingTheNarrative/materials.md": 577,
	"./RewritingTheNarrative/objectives.md": 574,
	"./RewritingTheNarrative/overview.md": 573,
	"./RewritingTheNarrative/pre-teaching.md": 578,
	"./RewritingTheNarrative/procedures.md": 579,
	"./RewritingTheNarrative/rewriting-the-narrative.png": 1179,
	"./RewritingTheNarrative/time.md": 575,
	"./TellingTheirStories/background.md": 565,
	"./TellingTheirStories/handouts.md": 570,
	"./TellingTheirStories/in-the-classroom.md": 571,
	"./TellingTheirStories/objectives.md": 566,
	"./TellingTheirStories/required-reading.md": 568,
	"./TellingTheirStories/supplemental-sources.md": 569,
	"./TellingTheirStories/supported-standards.md": 572,
	"./TellingTheirStories/telling-their-stories.png": 1180,
	"./TellingTheirStories/terms.md": 567,
	"./TheDeplorableEntanglement/context.md": 594,
	"./TheDeplorableEntanglement/essential-questions.md": 590,
	"./TheDeplorableEntanglement/grade-levels.md": 593,
	"./TheDeplorableEntanglement/lab.md": 597,
	"./TheDeplorableEntanglement/materials.md": 595,
	"./TheDeplorableEntanglement/objectives.md": 591,
	"./TheDeplorableEntanglement/overview.md": 589,
	"./TheDeplorableEntanglement/procedures.md": 596,
	"./TheDeplorableEntanglement/summary.md": 598,
	"./TheDeplorableEntanglement/time.md": 592,
	"./TheLionsSide/background.md": 539,
	"./TheLionsSide/closing-activity.md": 548,
	"./TheLionsSide/collaborative-practice.md": 547,
	"./TheLionsSide/essential-vocab.md": 543,
	"./TheLionsSide/extension-activity.md": 549,
	"./TheLionsSide/focus-question.md": 542,
	"./TheLionsSide/guided-instruction.md": 545,
	"./TheLionsSide/independent-practice.md": 546,
	"./TheLionsSide/lions-side.png": 1181,
	"./TheLionsSide/objective.md": 540,
	"./TheLionsSide/opening-activity.md": 544,
	"./TheLionsSide/resources.md": 541,
	"./TheLionsSide/teachers-note.md": 550,
	"./TravelingBack/background.md": 551,
	"./TravelingBack/construct.md": 556,
	"./TravelingBack/discuss.md": 557,
	"./TravelingBack/explore.md": 555,
	"./TravelingBack/extension.md": 558,
	"./TravelingBack/objective.md": 552,
	"./TravelingBack/pre-lesson.md": 553,
	"./TravelingBack/traveling-back.png": 1182,
	"./TravelingBack/warm-up.md": 554,
	"./WhoIsAHistorian/extension.md": 564,
	"./WhoIsAHistorian/instruction.md": 562,
	"./WhoIsAHistorian/objectives.md": 559,
	"./WhoIsAHistorian/resources.md": 560,
	"./WhoIsAHistorian/return.md": 563,
	"./WhoIsAHistorian/warm-up.md": 561,
	"./WhoIsAHistorian/who-is-a-historian.png": 1183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1178;